export default function FAQSection() {
  const faqs = [
    {
      q: '木瓜影视上的电视剧需要付费吗？',
      a: '木瓜影视所有电视剧均为免费在线观看，不收取任何费用。我们致力于为广大追剧爱好者提供高品质、无广告的免费观影体验，让您随时随地畅享精彩剧集。',
    },
    {
      q: '观看电视剧需要安装播放器或插件吗？',
      a: '不需要。木瓜影视采用先进的H5播放技术，您只需使用浏览器即可直接在线观看所有电视剧，无需安装任何播放器或插件，即点即播，方便快捷。',
    },
    {
      q: '电视剧更新速度快吗？',
      a: '木瓜影视拥有专业的资源更新团队，热门电视剧上线后会在第一时间同步更新，确保您不会错过任何精彩剧集。我们的资源库每日更新，追剧无忧。',
    },
    {
      q: '支持哪些设备观看？',
      a: '木瓜影视完美适配电脑、平板和手机等多终端设备。无论您是在家用电脑大屏观影，还是通勤时用手机追剧，都能获得流畅的观影体验。',
    },
    {
      q: '播放卡顿怎么办？',
      a: '我们提供了多条播放线路供您切换。如果当前线路播放不畅，可以尝试切换到其他线路。同时建议检查您的网络连接，确保网络畅通以获得最佳观影体验。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-100/60">
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于木瓜影视，您想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-colors">
                {faq.q}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}